<script>
import Label from "./Label.vue";
import Multiselect from "vue-multiselect";
export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      value: this.item_value,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
      d_check2: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn2] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn2]) ==
            this.item.displayOnValue2
          : this.selectedItem[this.item.displayOn2] == this.item.displayOnValue2
        : false,
      templateData: {
        "Template A": {
          purpose: "test",
          description: "description",
        },
      },
    };
  },
  computed: {
    displayBasedOnBanners() {
      if (this.$route?.params?.categoryName === "banners") {
        return !!(
          this.selectedItem?.additionalProp1?.mobile_dark ||
          this.selectedItem?.additionalProp1?.mobile_light ||
          this.selectedItem?.additionalProp1?.mobile_preview
        );
      }
      return true;
    },
    getTemplatePurpose() {
      if (this.$route.params.categoryName === "prescriptions") {
        if (this.value === "Template A") {
          return "To enable patients to request prescriptions for medications they need, while ensuring their details are recorded for verification. This template is ideal for straightforward prescription requests.";
        } else if (this.value === "Template B") {
          return "To manage both acute and repeat prescription requests, ensuring that each type of request is handled appropriately. This helps guide patients towards the correct process depending on the nature of their prescription.";
        } else if (this.value === "Template C") {
          return "To provide additional checks for repeat prescriptions, ensuring patients requesting a medication have had a prescription in the last 6 months. This helps streamline repeat prescription requests and ensures compliance with prescribing practices.";
        } else if (this.value === "Template D") {
          return "To handle urgent prescription requests, allowing patients to explain why the request is urgent and ensuring that any urgent requests are well-documented for further review.";
        } else if (this.value === "Template E") {
          return "To provide a form for both patients and chemists to request prescriptions, ensuring that chemists are also able to manage prescription requests on behalf of their clients. This template is particularly useful when prescriptions need to be managed through a pharmacy.";
        } else if (this.value === "Template F") {
          return "To ensure that patients requesting repeat prescriptions have received the medication within the last 6 months, supporting safe and compliant prescribing practices. Form includes Online Consultation for Acute Rx ";
        }
      } else if (this.$route.params.categoryName === "feedback") {
        if (this.value === "Template A") {
          return "To collect basic patient information and details regarding the complaint, including the outcome the patient hopes to achieve.";
        } else if (this.value === "Template B") {
          return "To address new concerns or follow up on unresolved issues by capturing the history of the complaint or concern, including patient preferences for contact and third-party management.";
        } else if (this.value === "Template C") {
          return "To provide an option for formal complaints and to specify whether an investigation is required, with clear communication on the desired outcome and next steps.";
        } else if (this.value === "Template D") {
          return "To allow patients to request specific actions, such as an investigation or formal handling of the complaint, and to clearly define expectations regarding the response time and outcome.";
        } else if (this.value === "Template E") {
          return "To provide a straightforward option for submitting complaints with minimal detail required, aimed at those looking for a quicker and easier submission process.";
        }
      } else if (this.$route.params.categoryName === "carerinformation") {
        if (this.value === "Template A") {
          return "To collect essential information about the carer and the person being cared for, including contact details, health status, and care requirements.";
        } else if (this.value === "Template B") {
          return "To collect detailed information about the carer and the person they care for, similar to Template A but with additional details on Lasting Power of Attorney.";
        }
        else if (this.value === "Template C") {
          return "To gather detailed carer and cared-for patient information similar to template A, including additional details like NHS number, emergency contact details, medical consent, surgery registration details and referral preferences";
        }
      }
    else if (this.$route.params.categoryName === "cancelappointments") {
        if (this.value === "Template A") {
          return "The purpose of Template A is to provide a simple and accessible method for patients to notify the practice of appointment cancellations. This helps reduce missed appointments, improves scheduling efficiency, and ensures that appointment slots can be reallocated to other patients. Collecting essential information also helps verify the patient’s identity and maintain accurate records.";
        } else if (this.value === "Template B") {
          return "The purpose of Template B is to support appointment cancellation in multi-site or multi-department practices, where identifying the appointment location is important for accurate processing. This form ensures that cancellations are directed to the correct team, reducing administrative errors and improving patient service. Like Template A, it helps manage appointment availability and supports efficient scheduling.";
        }
      } else if (this.$route.params.categoryName === "sick/fitnotes") {
        if (this.value === "Template A") {
          return "To allow patients to request a sick/fit note (medical statement) where appropriate, ensuring the practice receives all necessary information to review and process the request efficiently.";
        } else if (this.value === "Template B") {
          return "To provide an enhanced Sick/Fit Note request template that captures additional employment-related information, enabling the practice to determine the purpose of the medical note and process requests appropriately.";
        }
      }
      return "";
    },
    getTemplateDescription() {
      if (this.$route.params.categoryName === "prescriptions") {
        if (this.value === "Template A") {
          return "<p>This template allows patients to request a prescription. It captures the patient’s personal details (name, date of birth, phone number, and email) and includes a section for the medication request, specifying the item description, strength, and quantity. There is also a field for additional comments related to the request. The patient can opt to have a copy of the form emailed to them and confirms their registration with the GP website.</p>";
        } else if (this.value === "Template B") {
          return "<p>This template differentiates between <strong>acute and repeat prescription requests</strong>. If the request is <strong>acute</strong>, the patient is prompted to submit an online consultation. For <strong>repeat</strong> prescriptions, the patient enters their personal details and medication requirements, similar to Template A. The form also provides an option for the patient to receive a copy of the form and confirms registration with the GP website.</p>";
        } else if (this.value === "Template C") {
          return '<p>This template captures whether a<strong> prescription request is acute or repeat</strong>. For repeat prescriptions, it asks if the patient has had the medication within the last 6 months. If the patient answers "Yes," the form continues similarly to Standard Template. If "No" is selected, the patient is prompted to submit an online consultation. The rest of the form includes personal details, medication request information, and a request for an email copy of the form.</p>';
        } else if (this.value === "Template D") {
          return "<p>This form is for <strong>urgent prescription requests that fall outside the standard ordering system</strong>. In addition to basic patient information and medication request details, it asks for the reason for the urgent request and whether the patient has suggestions for avoiding urgent prescriptions in the future. Like other templates, it includes an option for receiving a copy of the form and confirms registration with the GP website.</p>";
        } else if (this.value === "Template E") {
          return "<p>This template allows both <strong>patients and chemists to request prescriptions</strong>. When a patient selects this option, the form captures personal details, medication request information, and additional comments, similar to Template A. If a chemist is selected, the form includes additional fields for pharmacy information (e.g., pharmacy name, address). Both options allow patients or chemists to request prescriptions for medications and confirm their registration with the GP website.</p>";
        } else if (this.value === "Template F") {
          return "<p> This webform helps differentiate between <strong>acute and repeat prescription requests</strong>. Patients requesting <strong>acute</strong>, patients are directed to submit an online consultation. For <strong>repeat</strong> prescriptions, the form checks whether the patient has had the medication within the past 6 months. If so, the form proceeds similarly to the standard prescription request form. If not, the patient is again prompted to submit an online consultation. The form also collects personal details, specific medication request information, and offers an option to receive an email copy of the submission.</p>";
        }
      } else if (this.$route.params.categoryName === "feedback") {
        if (this.value === "Template A") {
          return "<p>This template is used for submitting a complaint or concern. It gathers essential personal details (name, date of birth, contact preferences), and captures the patient's perspective on the issue. It also allows the user to nominate a third party to manage the complaint. The template includes a section for describing the expected outcome of the complaint and gives the option to have the form emailed to the patient.</p>";
        } else if (this.value === "Template B") {
          return "<p>This template is used when a <strong>concern has been previously raised</strong>. The form asks whether the issue has been raised before, and if so, it includes a prompt for the patient to explain why they are dissatisfied with previous handling. If no prior complaint was made, the form invites the patient to provide details on the issue. Like Template A, it collects personal details, the issue description, and expected outcomes. It also gives the option to nominate a third party and request the form's contents to be emailed.</p>";
        } else if (this.value === "Template C") {
          return "<p>This template is designed to allow patients to submit a formal complaint, with options to <strong>request a formal investigation or simply seek acknowledgment and explanation of a concern</strong>. It captures patient details, the nature of the complaint, the desired outcome, and an option to receive a copy of the form by email. It distinguishes between formal complaints and concerns requiring acknowledgment, and allows the nomination of a third party to manage the complaint.</p>";
        } else if (this.value === "Template D") {
          return "<p>This template captures similar information to Template C but provides more detailed options for handling the complaint or concern. It includes the same patient information fields but emphasizes the level of investigation required. The patient is asked to select between an <strong>informal concern or a formal investigation</strong>, with a reminder that <strong>formal investigations may take longer</strong>. This template also includes the option for third-party management and form emailing.</p>";
        } else if (this.value === "Template E") {
          return "<p>Template E is a more streamlined version of the complaint form, primarily focusing on essential details such as patient identification, preferred contact method, and expected outcome. There are fewer options and no investigation-specific questions. It is simpler and quicker to fill out but still offers the ability to nominate a third party and request an emailed copy of the form. <strong>Does not allow to capture Phone Number</strong>.</p>";
        }
      } else if (this.$route.params.categoryName === "carerinformation") {
        if (this.value === "Template A") {
          return "<p>This template gathers the carer's personal information, the person's details being cared for, and asks about relevant conditions such as any existing Lasting Power of Attorney, involvement with armed forces, and whether the carer receives carer's allowance. It also includes questions about the additional support the carer may need and consents for sharing information with relevant support services. The form concludes with a consent statement for data recording and communication.</p>";
        } else if (this.value === "Template B") {
          return "<p>Template B gathers similar information to Template A, with additional questions related to the type of Lasting Power of Attorney in place (Property and Financial Affairs, Health and Welfare, or both). It also asks for the carer’s consent to share details with local carers’ support services and includes options for additional support needs. The form ensures that data related to the carer and the cared-for person is recorded appropriately, and the carer confirms the responsibility to update changes in details.</p>";
        }
        else if (this.value === "Template C") {
          return "<p>This form is used to collect detailed information about a carer and the person they care for. It includes standard carer details (as per Template B), along with additional fields such as the cared-for person’s NHS Number, emergency contact number, medical information consent, and surgery name (if the person is not registered with the current practice). The form also captures the carer’s preferred Carers Support option and referral preference to ensure the request is processed accurately</p>";
        }
      } 
      else if (this.$route.params.categoryName === "cancelappointments") {
        if (this.value === "Template A") {
          return "<p>Template A is a standard online form used by registered patients to cancel a scheduled appointment at their healthcare practice. The form collects personal information such as the patient’s first and last name, date of birth, phone number, and details of the appointment including type, date, and time. Patients are also asked to provide a reason for cancellation and confirm that they are registered at the practice. An optional checkbox allows patients to receive an email copy of the submitted form</p>";
        } else if (this.value === "Template B") {
          return "<p>Template B is an enhanced version of the cancellation form for registered patients, similar to Template A but with the additional field for Appointment Location. This field allows practices with multiple sites or departments to identify where the appointment was scheduled to take place. The form gathers the same personal and appointment information as Template A, and also offers an email copy option and registration confirmation checkbox.</p>";
        }
      } else if (this.$route.params.categoryName === "sick/fitnotes") {
        if (this.value === "Template A") {
          return "<p>This template captures key information required to issue a sick/fit note. The form collects details including the length of time the patient has been off work and whether the request is a repeat sick note.</p><p>Patients are required to enter their personal details, including first name, last name, gender, date of birth, contact information, and address details. The form also captures the start and end dates requested for the sick/fit note, along with a description of the illness and the reason the note is required.</p>";
        } else if (this.value === "Template B") {
          return "<p>This template functions similarly to Template A, collecting the patient's personal details, absence duration, requested fit note dates, illness description, and confirmation of registration. However, this version includes additional questions to clarify whether the request is a repeat sick note and whether the note is required for an employer/workplace or for DWP/Job Centre purposes. Where applicable, the patient is also required to provide their job title.</p>";
        }
      }
      return "";
    },
    showtemplatedetails() {
      if (
        this.$route.params.categoryName === "feedback" &&
        this.item_key === "option_template" &&
        (this.selectedItem.title === "Concerns / Complaints" ||
          this.selectedItem.title === "Complaints")
      ) {
        return true;
      } else if (
        this.$route.params.categoryName === "prescriptions" &&
        this.item_key === "template" &&
        this.selectedItem.title === "Webform"
      ) {
        return true;
      } else if (
        this.$route.params.categoryName === "carerinformation" &&
        this.item_key === "template" &&
        this.selectedItem.name === "Carer Information"
      ) {
        return true;
      } else if (
        this.$route.params.categoryName === "cancelappointments" &&
        this.item_key === "template" &&
        this.selectedItem.title === "Webform"
      ) {
        return true;
      } else if (
        this.$route.params.categoryName === "sick/fitnotes" &&
        this.item_key === "template" &&
        this.selectedItem?.additionalProp1?.sick_fit_notes_form_type === "Online Form"
      ) {
        return true;
      }
      return false;
    },
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    display_none_check2: {
      get: function () {
        return this.d_check2;
      },
      set: function (newValue) {
        this.d_check2 = newValue;
      },
    },
    isGlobal() {
      return this.selectedItem?.additionalProp1?.global || false;
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
        if (val && this.item.displayOn2 && val.key == this.item.displayOn2) {
          if (typeof val.value != "string") {
            this.display_none_check2 =
              JSON.stringify(val.value) == this.item.displayOnValue2
                ? true
                : false;
          } else {
            this.display_none_check2 =
              val.value == this.item.displayOnValue2 ? true : false;
          }
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
    display_none_check2(val) {
      this.item.display = this.item.displayOn2 && !val ? false : true;
    },
  },
};
</script>
<template>
  <div
    v-if="displayBasedOnBanners"
    class="mb-3"
    :class="{
      'd-none':
        (item.displayOn && !display_none_check) ||
        (item.displayOn2 && !display_none_check2),
    }"
  >
    <Label v-if="!item.hideLabel" :item="item" />
    <multiselect
      v-model="value"
      :options="item.options"
      :searchable="false"
      :close-on-select="true"
      :show-labels="false"
      :allow-empty="false"
      :placeholder="item.placeholder"
      :disabled="
        this.$route.params.categoryName == 'globalupdate'
          ? false
          : isGlobal
          ? true
          : false
      "
    ></multiselect>
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
    <div class="template-details" v-if="showtemplatedetails">
      <div class="templatepurpose" v-if="getTemplatePurpose !== ''">
        <div class="purpose-label">{{ "Purpose" }}</div>
        <div class="purpose-value">{{ getTemplatePurpose }}</div>
        <div class="descriptio-label" v-if="getTemplateDescription !== ''">
          {{ "Description" }}
        </div>
        <div
          class="description-value"
          v-if="getTemplateDescription !== ''"
          v-html="getTemplateDescription"
        ></div>
      </div>
    </div>
  </div>
</template>

<style>
.multiselect__select {
  z-index: 1;
}
.purpose-label {
  padding-bottom: 10px;
  color: #333333;
  font-weight: 500;
}
.descriptio-label {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #333333;
  font-weight: 500;
}
.templatepurpose {
  padding: 15px 0px;
}
.purpose-value,
.description-value {
  color: #65707b;
}
</style>
